<template>
  <CollapseItems
    title-class-header="h6"
    title-weight-header="normal"
  >
    <template #title>
      <div>
        <span class="font-weight-bolder mr-2">
          {{ cycle.cycle_name }}
        </span>
        {{ cycle.begin | moment('DD/MM/YY') }} - {{ cycle.end | moment('DD/MM/YY') }}
      </div>
    </template>
    <template #content>
      <v-sheet
        v-if="!cycle.disabled"
        :key="cycle.id"
        class="text-black-50 p-4"
      >
        <v-container :fluid="true">
          <v-row>
            <v-col
              lg="8"
              md="9"
              sm="12"
              cols="12"
              class="mt-4 mt-md-0"
            >
              <ModuleColumn
                v-if="cycle.count_modules > 0"
                :cycle="cycle"
              />
              <div
                v-else-if="cycle.is_finished && !cycle.released"
                class="text-center"
              >
                <p class="text-sm-subtitle-1 font-weight-bold mb-1">
                  Ciclo finalizado. Nenhum módulo foi selecionado para este ciclo.
                </p>
              </div>
              <v-col v-else-if="modulesSelectionIsPending">
                <ChooseModulesWarning :cycle="cycle" />
              </v-col>
            </v-col>
            <v-col
              lg="4"
              md="3"
              sm="12"
              cols="12"
              class="mt-4 mt-md-0"
            >
              <ChallengeColumn :cycle="cycle" />
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </template>
  </CollapseItems>
</template>
<script>
import CollapseItems from "@/common/components/CollapseItems.vue";
import ModuleColumn from '@/student/components/module/ModuleColumn'
import ChallengeColumn from '@/student/components/challenge/ChallengeColumn'
import ChooseModulesWarning from './ChooseModulesWarning'

export default {
  components: {
    CollapseItems,
    ModuleColumn,
    ChallengeColumn,
    ChooseModulesWarning,
  },
  props: {
    cycle: {
      type: Object,
      required: true
    },
  },
  computed: {
    modulesSelectionIsPending() {
      return this.cycle.released || this.cycle.should_select_modules
    }
  },
}
</script>
